var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKakaotalk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#FEE500"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0579 9.65259C13.8355 9.65259 8.81738 13.667 8.81738 18.5406C8.81738 21.704 10.9049 24.4739 14.0362 26.0556L12.9764 30.0139C12.9564 30.0733 12.9533 30.1369 12.9675 30.1979C12.9817 30.2589 13.0125 30.3147 13.0567 30.3591C13.121 30.4158 13.2037 30.4472 13.2895 30.4474C13.3606 30.4417 13.4281 30.4136 13.4822 30.3672L18.0426 27.2921C18.7158 27.385 19.3944 27.4333 20.0739 27.4366C26.2883 27.4366 31.3144 23.4222 31.3144 18.5406C31.3144 13.659 26.2723 9.65259 20.0579 9.65259Z",
    fill: "#392020"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKakaotalk);
export default __webpack_public_path__ + "static/media/kakaotalk.e7d53f920ffd5692af9cc67a8733e6be.svg";
export { ForwardRef as ReactComponent };